<div class="feedback-widget" [class]="color!">
  <div class="header">
    <span>{{title}}</span>
    <!--<span>Punkte: {{score}}</span>-->
  </div>
  <p>{{text}}</p>
</div>